import React from "react";
import { node } from "prop-types";
import releaseNotesApp, {
	fetchProps,
} from "@insightfulscience/contentful/Apps/ReleaseNotes";
import { WithLocale } from "@insightfulscience/i18";
import pipe from "@insightfulscience/shared-utils/fn/pipe";
import SiteLayout from "@src/SiteLayout";
import SectionTryForFree from "@src/SectionTryForFree";

import PageMeta from "@insightfulscience/smart-react/PageMeta";
import { contentfulProps } from "@src/config";
import resources from "../../locales/updates-page";

const ReleaseNotesLayout = ({ children }) => {
	return (
		<SiteLayout>
			<PageMeta>
				<PageMeta.OGP
					image="/images/snapgene/meta/preview-snapgene-dotmatics.png"
					imageSecureUrl="/images/snapgene/meta/preview-snapgene-dotmatics.png"
					isImageBaseUrl
				/>
				<PageMeta.Twitter
					image="/images/snapgene/meta/preview-snapgene-dotmatics.png"
					isImageBaseUrl
				/>
			</PageMeta>
			{children}
			<SectionTryForFree />
		</SiteLayout>
	);
};

ReleaseNotesLayout.propTypes = {
	children: node.isRequired,
};

const ContentfulReleaseNotesApp = releaseNotesApp({
	Layout: pipe(ReleaseNotesLayout, WithLocale({ resources })),
	contentfulProps,
	pageProps: {
		brandCode: "sg",
		siteDomain: "https://www.snapgene.com",
	},
	mode: "isr",
});

export const getStaticPaths = async () => {
	/*
		We do not pregenerate pages for updates, as there is too much of them.
		We just allow them to be rendered when needed and added to cache.
	*/
	return {
		paths: [],
		fallback: "blocking",
	};
};

export const getStaticProps = async ({ params: { slug } }) => {
	const props = await fetchProps(contentfulProps, slug, false);

	return props?.post
		? {
				props,
				revalidate: false,
			}
		: { notFound: true };
};

export default ContentfulReleaseNotesApp;
